import actions from 'redux-auto'
import Api from '#services/api'

export const useWissensportalData = async (azubiIds) => {
  try {
    const apiData = await Api.getAllCoursesForAzubis(azubiIds)
    return {
      allAzubisWithCourses: apiData.allAzubisWithCourses,
      uniqueCourses: apiData.uniqueCourses,
      uniqueModules: apiData.uniqueModules,
    }
  } catch (e) {
    actions.error.writeError({error: e})
    return {
      allAzubisWithCourses: [],
      uniqueCourses: [],
      uniqueModules: [],
    }
  }
}
